import Config from '@/config.js'
import store from '@/store'
if (!store.state.config.apiurl) {
  store.commit('storeConfig', Config)
}
var grvengine = {
  headers: function (server) {
    if (server === 'erp') {
      return new Headers({
        Authorization: Config.apikey,
        'Content-Type': 'application/json',
      })
    }
    return new Headers({
      Authorization: 'Bearer ' + store.state.auth.accessToken,
      'Content-Type': 'application/json',
    })
  },

  get_listaGrvlens () {
    const url = Config.apiurl + '/secure/lista_grvlens'
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_listaGrvmodels () {
    const url = Config.apiurl + '/secure/lista_grvmodels'
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_listaGrvaccessory () {
    const url = Config.apiurl + '/secure/lista_grvaccessory'
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  // #################### Handler response and error ########################################################################
  handleResponse: function (response) {
    // console.log('handleResponse', response)
    var payload = response.json()
    if (response.status === 401) {
      store.commit('setSnack', { message: 'Response Err: ' + response.status + ' Type:' + response.type + ' # ' + response.statusText, color: '#c54747d4' })
      store.dispatch('logout')
      return
    }
    if (response.status !== 200 && !payload) {
      store.commit('setSnack', { message: 'Response Err: ' + response.status + ' Type:' + response.type + ' # ' + response.statusText, color: '#c54747d4' })
      return
    }
    return payload
  },
  handleResult: function (payload) {
    if (payload.error) {
      store.commit('setSnack', { message: 'Error ' + payload.error_code + ' ' + payload.error_reason, color: '#c54747d4' })
      if (payload.error_code === 90) {
        store.dispatch('logout')
      }
      //   return false
      throw new Error(JSON.stringify(payload))
    }
    return payload
  },
  handleError: function (error, url) {
    var errormsg = url + '<hr> General Error'
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      errormsg = JSON.stringify(error.response)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request)
      errormsg = JSON.stringify(error.response)
    } else {
      // Something happened in setting up the request that triggered an Error

      try {
        var payload = JSON.parse(error.message)
        if (payload.error) {
          console.log('###payload Error', payload)
          errormsg = payload.error_reason
        }
      } catch (e) {
        console.log('### Error', url, error.message)
        errormsg = JSON.stringify(error.message)
      }
    }
    store.commit('setSnack', { message: url + '<hr>' + errormsg, color: '#c54747d4' })
  },
}
export default grvengine
